export const init = () => {
    const observer = new MutationObserver(() => {
        if (document.querySelector('[data-ng-link]') && document.querySelector('.js-ng-link') && document.querySelector('.js-ng-link-target')) {
            const ngLinks = document.querySelectorAll('[data-ng-link]:not([data-ng-link-applied])');
            ngLinks.forEach((item) => {
                const getData = item.dataset.ngLink;
                const [form, viewPage, id, type = "big"] = getData.split(",");

                const origin = "https://ng.dlubal.com/default.aspx";
                let newHtmlGoToCms;
                if (type === "big") {
                    newHtmlGoToCms = `
                    <a href="${origin}?form=${form}&id=${id}&viewpage=${viewPage}" class="g-go-to-cms" target="_blank" title="Click to edit"></a>
                `;
                } else if ((type === "small")) {
                    newHtmlGoToCms = `
                    <a href="${origin}?form=${form}&id=${id}&viewpage=${viewPage}" class="g-go-to-cms g-go-to-cms--small" target="_blank" title="Click to edit"></a>
                `;
                }


                item.setAttribute('data-ng-link-applied', true);

                if (item?.classList.contains('js-ng-link-target')) {
                    item?.insertAdjacentHTML('afterbegin', newHtmlGoToCms);
                } else {
                    item?.querySelector('.js-ng-link-target')?.insertAdjacentHTML('afterbegin', newHtmlGoToCms);
                }
            });
        }
    })



    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};  